import { render, staticRenderFns } from "./license.vue?vue&type=template&id=35bad7b9&scoped=true"
import script from "./license.vue?vue&type=script&lang=js"
export * from "./license.vue?vue&type=script&lang=js"
import style0 from "./license.vue?vue&type=style&index=0&id=35bad7b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bad7b9",
  null
  
)

export default component.exports